import { useSyncExternalStore } from "react";
import { closeActivityMenu } from "./useActivityMenu";

let open = false;
const listeners = new Set<() => void>();
const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
const snapshot = () => open;
function setOpen(value: boolean) {
  if (open === value) return;
  open = value;
  if (open) closeActivityMenu();
  for (const listener of listeners) listener();
}
const show = () => setOpen(true);
const close = () => setOpen(false);
const toggle = () => setOpen(!open);

export function useKeyboardShortcuts() {
  return {
    open: useSyncExternalStore(subscribe, snapshot),
    show,
    close,
    toggle,
  };
}
